/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { css } from 'emotion';
import { border, background } from '@guardian/src-foundations/palette';
import { textSans } from '@guardian/src-foundations/typography';
import { Button } from '@guardian/src-button';
import { SvgCheckmark } from '@guardian/src-icons';
import { space } from '@guardian/src-foundations';
const roleTextSize = (role) => {
    switch (role) {
        case 'immersive':
        case 'inline':
        case 'showcase': {
            return textSans.medium({ lineHeight: 'regular' });
        }
        case 'halfWidth':
        case 'supporting':
        case 'thumbnail': {
            return textSans.small({ lineHeight: 'regular' });
        }
    }
};
const roleHeadlineSize = (role) => {
    switch (role) {
        case 'immersive':
        case 'inline':
        case 'showcase': {
            return textSans.large({
                fontWeight: 'bold',
                lineHeight: 'regular',
            });
        }
        case 'halfWidth':
        case 'supporting':
        case 'thumbnail': {
            return textSans.medium({
                fontWeight: 'bold',
                lineHeight: 'regular',
            });
        }
    }
};
const roleButtonSize = (role) => {
    switch (role) {
        case 'immersive':
        case 'inline':
        case 'showcase': {
            return 'default';
        }
        case 'halfWidth':
        case 'supporting':
            return 'small';
        case 'thumbnail': {
            return 'xsmall';
        }
    }
};
const roleButtonText = (role) => {
    switch (role) {
        case 'immersive':
        case 'inline':
        case 'showcase':
        case 'halfWidth':
        case 'supporting': {
            return 'Allow and continue';
        }
        case 'thumbnail': {
            return 'Allow';
        }
    }
};
const shouldDisplayOverlay = ({ isTracking, isOverlayClicked, isInABTestVariant, isMainMedia, isPreview, }) => {
    if (isMainMedia || !isTracking) {
        return false;
    }
    if (isOverlayClicked) {
        return false;
    }
    return isInABTestVariant || isPreview;
};
const isInABTestVariant = (abTestConfig) => {
    return abTestConfig.clickToViewVariant === 'variant';
};
export const ClickToView = ({ children, role = 'inline', onAccept, isTracking, isMainMedia, source, sourceDomain = 'unknown', abTests, isPreview, }) => {
    const [isOverlayClicked, setIsOverlayClicked] = useState(false);
    const handleClick = () => {
        setIsOverlayClicked(true);
        if (onAccept) {
            setTimeout(() => onAccept());
        }
    };
    const textSize = roleTextSize(role);
    if (shouldDisplayOverlay({
        isTracking,
        isOverlayClicked,
        isInABTestVariant: isInABTestVariant(abTests),
        isMainMedia,
        isPreview,
    })) {
        return (React.createElement("div", { className: css `
					width: 100%;
					background: ${background.secondary};
					border: 1px solid ${border.secondary};
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					padding: ${space[1]}px ${space[6]}px ${space[3]}px;
					margin-bottom: ${space[3]}px;
				`, "data-component": `click-to-view:${sourceDomain}` },
            React.createElement("div", { className: css `
						${roleHeadlineSize(role)}
						margin-bottom: ${space[1]}px;
					` }, source
                ? `Allow ${source} content?`
                : 'Allow content provided by a third party?'),
            React.createElement("p", { className: css `
						${textSize}
					` }, source ? (React.createElement(React.Fragment, null,
                "This article includes content provided by ",
                source,
                ". We ask for your permission before anything is loaded, as they may be using cookies and other technologies. To view this content,",
                ' ',
                React.createElement("strong", null, "click 'Allow and continue'"),
                ".")) : (React.createElement(React.Fragment, null,
                "This article includes content hosted on",
                ' ',
                sourceDomain,
                ". We ask for your permission before anything is loaded, as the provider may be using cookies and other technologies. To view this content,",
                ' ',
                React.createElement("strong", null, "click 'Allow and continue'"),
                "."))),
            React.createElement("div", { className: css `
						margin-top: ${space[5]}px;
					` },
                React.createElement(Button, { priority: "primary", size: roleButtonSize(role), icon: React.createElement(SvgCheckmark, null), iconSide: "left", onClick: () => handleClick(), "data-link-name": "allow-button" }, roleButtonText(role)))));
    }
    return React.createElement(React.Fragment, null, children);
};
